<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.size"
            :error-messages="sizeErrors"
            :label="$t('profile.printingsurface.size')"
            required
            step="0.1"
            @input="$v.item.size.$touch()"
            @blur="$v.item.size.$touch()"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';


export default {
  name: 'PrintingSurfaceSizeForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        size: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    sizeErrors() {
      const errors = [];

      if (!this.$v.item.size.$dirty) return errors;

      has(this.violations, 'size') && errors.push(this.violations.size);

      !this.$v.item.size.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      size: {
        required,
      },
    }
  }
};
</script>
